'use client';

import Cookies from 'js-cookie';
import Link from 'next/link';
import { useTranslations } from '@power-core/toolkit';
import { type FunctionComponent, useEffect } from 'react';

import { useAppContext } from '@/modules/app-context/use-app-context';
import { useNavigation } from '@/modules/utils/custom-hooks/use-navigation';
import { Flexbox } from '@/ui-components/flexbox/flexbox';
import { Paragraph } from '@/ui-components/paragraph/paragraph';

export const Footer: FunctionComponent = () => {
	const t = useTranslations();
	const { addSearchParam } = useNavigation();
	const { appConfig } = useAppContext();
	//TODO Commented out for now, as the privacy notice URL is a static link.
	// const locale = Cookies.get('NEXT_LOCALE');
	// const privacyNoticeUrl = appConfig?.privacyPolicyUrl ? `${appConfig?.privacyPolicyUrl}/${locale}` : '#';

	const handleOpenPdf = () => {
		window.open('/TermsOfUse_ABBPowerCore.pdf', '_blank');
	};

	const handleOpenModal = () => {
		addSearchParam({ key: 'modal', value: 'CookieSettings' });
	};

	useEffect(() => {
		const hasSeenModal = Cookies.get('hasSeenCookieModal');

		if (!hasSeenModal) {
			handleOpenModal();
		}
	}, []);

	return (
		<Flexbox alignContent='center' justify='between' className='border-t pt-4 pb-5 px-9'>
			<Flexbox justify='between' className='w-full'>
				<Paragraph variant='text-sm' className='text-n500_light_text'>{`©ABB ${appConfig?.appName} ${new Date().getFullYear()}`}</Paragraph>
				<Flexbox className='gap-8'>
					<Paragraph variant='text-sm' className='cursor-pointer'>
						<Link
							href={appConfig?.privacyPolicyUrl ? appConfig?.privacyPolicyUrl : '#'}
							target={appConfig?.privacyPolicyUrl ? '_blank' : '_self'}
						>
							{t('T_PRIVACY_NOTICE')}
						</Link>
					</Paragraph>
					<Paragraph variant='text-sm' className='cursor-pointer' onClick={handleOpenPdf}>
						{t('T_TERMS_OF_USE')}
					</Paragraph>
					<Paragraph variant='text-sm' className='cursor-pointer' onClick={handleOpenModal}>
						{t('T_COOKIE_SETTINGS')}
					</Paragraph>
					<Paragraph variant='text-sm' className='cursor-pointer' onClick={() => addSearchParam({ key: 'modal', value: 'Support' })}>
						{t('T_SUPPORT')}
					</Paragraph>
				</Flexbox>
				<Paragraph variant='text-sm' className='text-n500_light_text'>{`${t('T_VERSION')} ${appConfig?.appVersion}`}</Paragraph>
			</Flexbox>
		</Flexbox>
	);
};
